$mol_icon_square $mol_icon path \M3,3V21H21V3
